module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABQElEQVRo3u2ZwRGDIBBFKYESOOboLVdKoARLoANKSAmUQAmWQAkpwUvum8OOA0nE0ThRmHxndmREmX24ux9UEJFo2QQAAAAAAABgN8DjcqW19utjoy8AAAAAfgoQAluzAEqxNQUwjnz2nocXgtt5X9UAUhJZyzM/ASjF16RsAEDr5Pi7ad0AgLVlAGsrArjfUzvGNLt57L/blAta8zMzYx0HMM201ine+55oGMoAw8D3CEHUdSncsjdzHEAI804aUwYo9WVacWwOlBzdaqfkgPdcFvc6L2XKjUMBlkJlqxlzUgg5t995507WgRC+CyUpZxd65whZjFwW1zrfda86UIUSL9X/OT2obikxKbBSLFDOcXIaw+1c8LKqU/d+4Hb7SNK2NjTOAQAAuwC8X0xYfFYBAAAAgD80AAAAAADw5wBPVpONfzYSSq4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/flags/Canada.png
// module id = 272
// module chunks = 0